<template>
    <div>
    <div class="container mt-4 mb-4">
        <!-- <atras-component></atras-component> -->
        <boton-atras :nombre_ruta="'federal'"></boton-atras>
        <div class="row">
            <div class="col-md  mt-1 order-2 order-sm-2 order-md-1 order-lg-1">
                <h6 class="subtitulo mb-2">Leyes</h6>
                <div class="lineaNegra"></div>
                <div class="mt-1 mb-2 lineaNegra2"></div>

                <a href="https://www.diputados.gob.mx/LeyesBiblio/pdf/CPEUM.pdf" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Constitución Política de los Estados Unidos Mexicanos </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>

                <a href="https://www.diputados.gob.mx/LeyesBiblio/pdf/LGTAIP.pdf" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Ley General de Transparencia y Acceso a la Información Pública </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>

                <a href="https://www.diputados.gob.mx/LeyesBiblio/pdf/LFTAIP.pdf" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Ley Federal de Transparencia y Acceso a la Información Pública </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>

                <a href="https://www.diputados.gob.mx/LeyesBiblio/pdf/LFPRH.pdf" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Ley Federal de Presupuesto y Responsabilidad Hacendaria </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>

                <a href="https://www.diputados.gob.mx/LeyesBiblio/pdf/LFISAN.pdf" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Ley Federal del Impuesto sobre Automóviles Nuevos </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>

                <a href="http://www.diputados.gob.mx/LeyesBiblio/pdf_mov/Ley_de_Fiscalizacion_y_Rendicion_de_Cuentas_de_la_Federacion.pdf" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Ley de Fiscalización y Rendición de Cuentas de la Federación </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>

                <a href="https://www.diputados.gob.mx/LeyesBiblio/pdf/CFF.pdf" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Código Fiscal de la Federación </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>

                <a href="https://www.diputados.gob.mx/LeyesBiblio/pdf/LAdua.pdf" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Ley Aduanera </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>

                <a href="https://www.diputados.gob.mx/LeyesBiblio/pdf/LCF.pdf" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Ley de Coordinación Fiscal </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>

                <a href="https://www.diputados.gob.mx/LeyesBiblio/pdf/LGCG.pdf" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Ley General de Contabilidad Gubernamental </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>

                <a href="https://www.diputados.gob.mx/LeyesBiblio/pdf/LISR.pdf" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Ley del Impuesto Sobre la Renta </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>

                <a href="https://www.diputados.gob.mx/LeyesBiblio/pdf/LIVA.pdf" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Ley del Impuesto al Valor Agregado </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>

                <a href="https://www.diputados.gob.mx/LeyesBiblio/pdf/LIEPS.pdf" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Ley del Impuesto Especial sobre Producción y Servicios </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>

                <a href="http://www.diputados.gob.mx/LeyesBiblio/pdf/LGPDPPSO.pdf" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Ley General de Protección de Datos Personales en Posesión de Sujetos Obligados </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>

                <a href="https://www.diputados.gob.mx/LeyesBiblio/pdf/LDFEFM.pdf" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Ley de Disciplina Financiera de las Entidades Federativas y los Municipios </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>

                <a href="https://www.diputados.gob.mx/LeyesBiblio/pdf/LIF_2024.pdf" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Ley de Ingresos de la Federación para el Ejercicio Fiscal 2024</h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>

                <a href="https://www.diputados.gob.mx/LeyesBiblio/pdf/PEF_2024.pdf" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Presupuesto de Egresos de la Federación para el Ejercicio Fiscal 2024 </h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>
                <a href="https://www.poderjudicialchiapas.gob.mx/archivos/manager/7917FAFA-7A50-481A-AA5B-24E73C398706.pdf" target="_blank">
                    <div class="mb-2">
                        <div class="title_document" style="display:flex; justify-content:space-between;">
                             <div class="col-8">
                                <h5> Ley de Archivos del Estado de Chiapas</h5>
                            </div>
                            <div class="col-3">
                                <p class="descargar">Descargar <i class='bx bx-download icono-down'></i></p>
                            </div> 
                        </div> 
                    </div>
                </a>
            </div>            
            <div class="col-md order-1 order-sm-1 order-md-2 order-lg-2 ">
                <div class="row margenes img_fija">
                    <div class="sec_imagen"> 
                        <img src="@/assets/imagenes/banderaMexico.jpg" alt="">  
                    </div>
                </div>              
            </div>
        </div>
        <div class="text-aviso my-5">
            <h5> <span class="resaltado-vino">AVISO:</span> Los instrumentos jurídicos que se mencionan a continuación, son solo de referencia, encontrándose para su consulta oficial en el portal de internet de la <u><a href="https://www.sgg.chiapas.gob.mx/" target="_blank" class="resaltado-vino">Secretaría General de Gobierno</a></u>, o en su caso en la versión impresa en el órgano de difusión oficial.</h5>
        </div>
    </div>

    </div>
</template>

<script>
import atrasComponent from './../../reload.vue'
import botonAtras from './../../button-atras'
export default {
    mounted(){
        window.scrollTo(0, 0);
    },
    components:{
        atrasComponent,
        botonAtras
    }
}
</script>

<style scoped>
    .title_document { 
        padding: .8rem 1rem;             
        width: 100%;
        height: auto;
        border: 1px solid#dfdfdf ;
        border-radius: 5px;
        border-left: 3px solid #621132;

        display: flex;
        justify-content: space-between;
        align-items: center !important;
    } 

    .title_document:hover{
        box-shadow: 3px 8px 17px -13px rgba(0,0,0,0.75) !important;
    }

    .descargar{
        font-size: 0.9rem;
        color: #6c757d !important;
    }

    .subtitulo {
        font-weight: 400;
        font-size: 1.8rem;
        margin-top: 1rem;
    }
    .subtitulo2{
        font-weight: 400;
        font-size: 1.2rem;
        margin-top: .5rem;
        margin-bottom: 1rem ;
    }
    .title_document h5 {
        font-size: 0.9rem;
        font-weight: 400;
        /* line-height: 20px; */
    }

    .sec_imagen{ 
        width:85% !important;
        background-color: #560F2C;
        /* margin-top: 3rem; */
    }

    a{
        text-decoration: none !important;
        color: #212529;
    }
    a:hover{ color:#212529 !important; }
    /* margenes de la card consulta */
    .margenes{
        display: flex;
        justify-content: flex-end;
    }


    .text-aviso h5 {      

        font-size: 1rem;
        font-weight: 400;
        /* line-height: 20px; */
    }
    .resaltado-vino{
        color: #560F2C;
        font-weight: 500;
    }

    
    /* imagen fija */
    .img_fija{
        position: sticky !important;
        top: 7% !important;
        z-index: 1000 !important;
    }

@media only screen and (max-device-width : 900px) {
    .container{
        padding-right: 1% !important;
        padding-left: 1% !important;
    }
    .title_document{
        padding: .5rem 1rem .5rem .1rem;
        line-height: 20px;
    }

    /* margenes de la card consulta */
    .margenes{ justify-content: space-around; }
    .card-width{ width: 95%; }

    .subtitulo2{ font-size: 1rem; }

    .sec_imagen{ margin-top: 0rem; }


    .tab-select{
        position: initial;
        z-index: auto;
    }
}

</style>